import React, { useContext, useState } from "react";
import { css } from "emotion";
import { BuildContext } from "../../context/BuildSpotlightState";
import { boxStyles, textSizes, colors } from "../../styles/theme";
import GenericTextInput from "../GenericTextInput";
import Section from "../createNew/Section";
import NextButton from "./NextButton";
import TitleBlock from "./TitleBlock";

const HeadlineBuilder = () => {
  const {
    headline,
    setHeadline,
    type,
    setStage,
    setLastCompleted,
  } = useContext(BuildContext);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!headline) {
      setError("Make sure you fill out your headline text!");
      return;
    }
    if (type === "text") {
      setStage(3);
      setLastCompleted(3);
    } else {
      setStage(2);
      setLastCompleted(2);
    }
  };

  return (
    <div className={container}>
      <TitleBlock />
      <form onSubmit={handleSubmit}>
        <Section heading="Headline">
          <GenericTextInput
            placeholder="Add your headline"
            value={headline}
            onValueChange={setHeadline}
            maxLength={70}
          />
        </Section>
        <NextButton />
      </form>
      {error && (
        <div className="errorBox">
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default HeadlineBuilder;

const container = css`
  padding: ${boxStyles.standardPadding};
  display: flex;
  flex-direction: column;
  align-items: center;

  .errorBox {
    padding: ${boxStyles.standardPadding} 0;
    p {
      font-size: ${textSizes.normal};
      color: ${colors.cancel};
      text-align: center;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;
